// removed by extract-text-webpack-plugin
module.exports = {"controls":"envelope-modals__controls___1owYA","address":"envelope-modals__address___2jBEK"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-envelopes/envelope-modals.scss
// module id = 518
// module chunks = 0